export default __webpack_public_path__ + "static/media/404.41bc6439.png";